import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ButtonIcon from "components/button-icon";
import ButtonNewItem from "components/button-new-item";
import Loading from "components/center-loading";
import Delete from "components/delete-dialog";
import Filtro from "components/filters/filter-general";
import HeaderIcon from "components/header-icon";
import { GeneralIcon } from "components/icons/icn-index.icon";
import IconEmpty from "images/iconEmpty.icon";
import SnackBar from "material-ui/Snackbar";
import PropTypes from "prop-types";
import { Component } from "react";
import intl from "react-intl-universal";
import { isFeatureEnabled } from "utils/feature-flags";
import Fetch from "utils/fetch";
import { formatErrorMessage } from "utils/handle-error";
import StorePersist from "utils/store-persist";
import GeneralForm from "./form";
import { featureFlagDynamicInventoryPolicy } from "./form/general-form.service";
import * as services from "./general-master-data.service";
import ImportExport from "./importer-exporter";
import ImportExportDoiInventoryPolicy from "./importer-exporter-doi-inventory-policy";
import ImportExportDynamicInventoryPolicy from "./importer-exporter-dynamic-inventory-policy";
import GeneralList from "./list";

import "./general.css";
import { IconFilterActive } from "components/icons/icn-filter-active.icon";
import { IconFilterInactive } from "components/icons/icn-filter-inactive.icon";
import Sidebar from "components/sidebar";
import { profileAdminOrMasterData } from "services/permissions/getPermissions";
import { generateQueryParams } from "utils/custom-functions";

class General extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  };

  constructor() {
    super();
    let filter = StorePersist.getValuesJSON("filtersFamiliaRotuladaCentro");
    filter = filter ?? {
      IdCarteira: null,
      IdFamilia: null,
      IdFamiliaRotulada: null,
      IdCentro: null,
      IdCoordenacao: null,
    };
    this.state = {
      isFetching: false,
      generalData: [],
      total: 0,
      currentPage: 0,
      qtRegsPerPage: 50,
      openDelete: false,
      openEditMode: false,
      openModalForm: false,
      idSelected: 0,
      showFeedback: false,
      messageFeedBack: "",
      textMsg: "",
      terms: "",
      showFilter: false,
      filters: filter,
      filterOptions: null,
      openImportExport: false,
      openImportExportDynamicInventoryPolicy: false,
      openImportExportDoiInventoryPolicy: false,
      openImportExportGeneric: false,
      modalAutoPilot: false,
      featureFlagDynamicInventoryPolicies: false,
      featureFlagDoiDynamicInventoryPolicy: false,
      policyMenuAnchorEl: null,
    };
  }

  componentDidMount() {
    const filter = StorePersist.getValuesJSON("filtersFamiliaRotuladaCentro");
    if (filter) {
      this.setState({
        filters: filter,
      });
    }
    this.loadFeatureFlags();
  }

  loadFeatureFlags = async () => {
    try {
      const [weeklyFlag, doiFlag] = await Promise.all([
        featureFlagDynamicInventoryPolicy(),
        isFeatureEnabled("FeatureDoiDynamicInventoryPolicy"),
      ]);
      this.setState({
        featureFlagDynamicInventoryPolicies: weeklyFlag,
        featureFlagDoiDynamicInventoryPolicy: doiFlag,
      });
    } catch (error) {
      console.error("Erro ao carregar feature flags:", error);
    }
  };

  showFeedback = (message) => {
    this.setState({
      showFeedback: true,
      messageFeedBack: message,
    });
  };

  closeFeedback = () => {
    this.setState({
      showFeedback: false,
    });
  };

  openForm = () => {
    this.setState({
      openModalForm: true,
    });
  };

  openNewForm = () => {
    this.setState(
      {
        openEditMode: false,
      },
      () => this.openForm()
    );
  };

  openEditForm = (row) => {
    const { generalData } = this.state;
    const selected = generalData[row];

    this.setState(
      {
        openEditMode: true,
        idSelected: selected.Id,
      },
      () => this.openForm()
    );
  };

  redirect = (generalMaterial) => {
    const filter = {
      IdFornecedor: null,
      IdFamiliaRotuladaCentro: generalMaterial.Id,
    };

    StorePersist.setValuesJSON("filtersFamiliaRotuladaCentroMaterial", filter);
    this.props.history.push(`/master-data/general-material`);
  };

  closeForm = () => {
    this.setState({
      openModalForm: false,
      idSelected: 0,
    });
  };

  closeDelete = () => {
    this.setState({
      openDelete: false,
    });
  };

  openDelete = (id) => {
    this.setState({
      openDelete: true,
      idSelected: id,
    });
  };

  startFetching = () => {
    this.setState({
      isFetching: true,
    });
  };

  stopFetching = () => {
    this.setState({
      isFetching: false,
    });
  };

  proccessErro = (ex) => {
    this.stopFetching();
    this.showFeedback(formatErrorMessage(ex));
  };

  refreshSearch = () => {
    this.closeForm();
    this.search();
  };

  searchFilters = (filters) => {
    StorePersist.setValuesJSON("filtersFamiliaRotuladaCentro", filters);
    this.showFilter();

    this.setState(
      {
        currentPage: 0,
        filters,
      },
      () => this.search(this.state.currentPage)
    );
  };

  showFilter = async () => {
    const { filterOptions } = this.state;
    if (!filterOptions) await this.loadFilters();
    this.setState((prevState) => ({
      showFilter: !prevState.showFilter,
    }));
  };

  loadFilters = async () => {
    this.startFetching();
    const wallets = await services.getWallets();
    const families = await services.getFamilies();
    const labeledFamilies = await services.getLabeledFamilies();
    const centers = await services.getCenters();
    const coordinations = await services.getCoordinations();
    this.setState({
      filterOptions: {
        wallets,
        families,
        labeledFamilies,
        centers,
        coordinations,
        isFetching: false,
      },
    });
    this.stopFetching();
  };

  verifyFilter = () => {
    return (
      this.state.filters.IdCarteira > 0 ||
      this.state.filters.IdFamilia > 0 ||
      this.state.filters.IdFamiliaRotulada > 0 ||
      this.state.filters.IdCentro > 0 ||
      this.state.filters.IdCoordenacao > 0
    );
  };

  proccessData = (data) => {
    this.setState({
      generalData: data.Data,
      total: data.TotalRecordCount,
    });
  };

  delete = () => {
    const idLabeledFamily = this.state.idSelected;
    this.startFetching();
    Fetch.delete(`/labeled-family-centers/${idLabeledFamily}`)
      .then(() =>
        this.showFeedback(
          intl.get(
            "master-data.general.deleteLabeledFamilyModal.labeledFamilyCenterSuccessfullyDeleted"
          )
        )
      )
      .then(this.closeDelete)
      .then(this.search)
      .catch((e) => this.proccessErro(e))
      .finally(() => this.stopFetching());
  };

  search = (page) => {
    this.startFetching();
    const filters = StorePersist.getValuesJSON("filtersFamiliaRotuladaCentro");
    if (filters) {
      this.setState({ filters });
    }

    const nextPage = page === undefined ? this.state.currentPage : page;
    const _body = {
      CoordinationId: this.state.filters.IdCoordenacao,
      DestinationId: this.state.filters.IdCentro,
      FamilyId: this.state.filters.IdFamilia,
      LabeledFamilyId: this.state.filters.IdFamiliaRotulada,
      MaterialGroupId: this.state.filters.IdCarteira,
      _page: nextPage,
      _size: this.state.qtRegsPerPage,
    };

    Fetch.get(`/labeled-family-centers:paginated?${generateQueryParams(_body)}`)
      .then((response) => this.proccessData(response.data))
      .then(() => this.setState({ currentPage: nextPage }))
      .catch((e) => this.proccessErro(e))
      .finally(() => this.stopFetching());

    this.setState({
      showFilter: false,
    });
  };

  exportarPoliticaEstoque = () => {
    this.setState({
      openImportExport: true,
      policyMenuAnchorEl: null,
    });
  };

  openPolicyMenu = (event) => {
    this.setState({ policyMenuAnchorEl: event.currentTarget });
  };

  closePolicyMenu = () => {
    this.setState({ policyMenuAnchorEl: null });
  };

  openWeeklyPolicyModal = () => {
    this.setState({
      openImportExportDynamicInventoryPolicy: true,
      policyMenuAnchorEl: null,
    });
  };

  openDoiPolicyModal = () => {
    this.setState({
      openImportExportDoiInventoryPolicy: true,
      policyMenuAnchorEl: null,
    });
  };

  closeImportExport = () => {
    this.setState({
      openImportExport: false,
    });
  };

  closeImportExportDynamicInventoryPolicy = () => {
    this.setState({
      openImportExportDynamicInventoryPolicy: false,
    });
  };

  closeImportExportDoiInventoryPolicy = () => {
    this.setState({
      openImportExportDoiInventoryPolicy: false,
    });
  };

  openAutoPilot = (id) => {
    this.props.history.push(`/master-data/general-auto-pilot/${id}`);
  };

  render() {
    const {
      openModalForm,
      openEditMode,
      openDelete,
      idSelected,
      generalData,
      total,
      messageFeedBack,
      isFetching,
      showFeedback,
      showFilter,
      filters,
      openImportExport,
      openImportExportDynamicInventoryPolicy,
      openImportExportDoiInventoryPolicy,
      filterOptions,
    } = this.state;
    return (
      <div className="general-container">
        <Loading isLoading={isFetching} />
        <div className="general-header-container">
          <HeaderIcon
            title={intl.get("master-data.general.header.title")}
            subtitle={intl.get("master-data.general.header.subtitle")}
            icon={<GeneralIcon width="40px" height="40px" color="var(--color-brand-500)" />}
          >
            {profileAdminOrMasterData() && (
              <>
                <div title={intl.get("master-data.general.actions.policyMassUpload")}>
                  <ButtonIcon
                    onClick={this.openPolicyMenu}
                    buttonType="default"
                    buttonText={intl.get("master-data.general.actions.policyMassUpload")}
                    buttonIcon={<KeyboardArrowDownIcon />}
                    className={"button-img-estoque policy-mass-upload-button"}
                  />
                </div>
                <Menu
                  anchorEl={this.state.policyMenuAnchorEl}
                  open={Boolean(this.state.policyMenuAnchorEl)}
                  onClose={this.closePolicyMenu}
                  keepMounted
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                  PaperProps={{
                    style: {
                      width: this.state.policyMenuAnchorEl
                        ? this.state.policyMenuAnchorEl.offsetWidth
                        : undefined,
                    },
                  }}
                >
                  <MenuItem onClick={this.exportarPoliticaEstoque}>
                    {intl.get("master-data.general.actions.staticPolicy")}
                  </MenuItem>
                  {this.state.featureFlagDoiDynamicInventoryPolicy && (
                    <MenuItem onClick={this.openDoiPolicyModal}>
                      {intl.get("master-data.general.actions.doiPolicy")}
                    </MenuItem>
                  )}
                  {this.state.featureFlagDynamicInventoryPolicies && (
                    <MenuItem onClick={this.openWeeklyPolicyModal}>
                      {intl.get("master-data.general.actions.weeklyPolicy")}
                    </MenuItem>
                  )}
                </Menu>
              </>
            )}

            <div title={intl.get("master-data.general.actions.newRotuledFamily")}>
              <ButtonNewItem className="general-button" onClick={this.openNewForm} />
            </div>

            <div title={intl.get("master-data.general.actions.filter")} className="filterContainer">
              <ButtonIcon
                onClick={this.showFilter}
                buttonType="default"
                buttonText={intl.get("filters.filter")}
                buttonIcon={this.verifyFilter() ? <IconFilterActive /> : <IconFilterInactive />}
                className={"button-filter"}
              />
            </div>
          </HeaderIcon>
        </div>

        <GeneralList
          data={generalData}
          countData={total}
          refreshSearch={this.search}
          handleEdit={this.openEditForm}
          handleDelete={this.openDelete}
          qtRegsPerPage={this.state.qtRegsPerPage}
          handleRedirect={this.redirect}
          openConfgAutoPilot={this.openAutoPilot}
        />

        {openModalForm && (
          <GeneralForm
            idEdit={idSelected}
            open={openModalForm}
            editMode={openEditMode}
            handleClose={this.closeForm}
            handleRefresh={this.refreshSearch}
            handleFeedback={this.showFeedback}
            profileAdminOrMasterData={profileAdminOrMasterData()}
          />
        )}

        <Delete
          open={openDelete}
          title={intl.get("master-data.general.deleteLabeledFamilyModal.tooltipDescription")}
          handleClose={this.closeDelete}
          warningMessage={intl.get("master-data.general.materials.description")}
          handleConfirm={this.delete}
        />

        <Sidebar visible={showFilter} triggerClose={this.showFilter} icon={IconEmpty}>
          {showFilter && (
            <Filtro
              initialData={filters}
              showFilter={showFilter}
              handleClose={this.searchFilters}
              filterOptions={filterOptions}
            />
          )}
        </Sidebar>

        <SnackBar
          message={messageFeedBack}
          open={showFeedback}
          autoHideDuration={3000}
          onRequestClose={this.closeFeedback}
        />

        {openImportExport && (
          <ImportExport open={openImportExport} handleClose={this.closeImportExport} />
        )}

        {openImportExportDynamicInventoryPolicy && (
          <ImportExportDynamicInventoryPolicy
            open={openImportExportDynamicInventoryPolicy}
            handleClose={this.closeImportExportDynamicInventoryPolicy}
          />
        )}

        {openImportExportDoiInventoryPolicy && (
          <ImportExportDoiInventoryPolicy
            open={openImportExportDoiInventoryPolicy}
            handleClose={this.closeImportExportDoiInventoryPolicy}
          />
        )}

        {this.state.modalAutoPilot && (
          <AutoPilot
            handleClose={this.closeAutoPilot}
            isOpen={this.state.modalAutoPilot}
            idLabeledFamilyCenter={this.state.idSelected}
            saveAutoPiloteSchedule={this.saveAutoPiloteSchedule}
            showFeedback={this.showFeedback}
          />
        )}
      </div>
    );
  }
}

export default General;
